import { QueryClient } from "@tanstack/react-query";

import { AppError } from "@/lib/errors";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      // One retry by default, but never retry permission failures — they
      // can't succeed without an admin granting access.
      retry: (failureCount, err) => {
        if (err instanceof AppError && err.isPermissionDenied) return false;
        return failureCount < 1;
      },
    },
  },
});
